import ABS1 from "../assets/images/ABS_1.svg";
import ABS2 from "../assets/images/ABS_2.svg";
import ABS3 from "../assets/images/ABS_3.svg";
import ABS4 from "../assets/images/ABS_4.svg";
import ABS5 from "../assets/images/ABS_5.svg";
import EVA1 from "../assets/images/EVA_1.svg";
import EVA2 from "../assets/images/EVA_2.svg";
import EVA3 from "../assets/images/EVA_3.svg";
import EVA4 from "../assets/images/EVA_4.svg";
import EVA5 from "../assets/images/EVA_5.svg";
import TOG1 from "../assets/images/TOG_1.svg";
import TOG2 from "../assets/images/TOG_2.svg";
import TOG3 from "../assets/images/TOG_3.svg";
import TOG4 from "../assets/images/TOG_4.svg";
import TOG5 from "../assets/images/TOG_5.svg";
import CartIcon from "../assets/images/cart.svg";
import CloseIcon from "../assets/images/close_icon.svg";
import SelectIcon from "../assets/images/icon_select.svg";
import KenguruGoldIcon from "../assets/images/kenguru_logo.png";
import SuggestionsInfoIcon from "../assets/images/suggestion_info.svg";
import WikiCategory1 from "../assets/images/wiki_category_1.svg";
import WikiCategory2 from "../assets/images/wiki_category_2.svg";
import WikiCategory3 from "../assets/images/wiki_category_3.svg";
import WikiCategory4 from "../assets/images/wiki_category_4.svg";

interface Asset {
  asset: any;
  url: string;
}

export class AssetManager {
  private static assets: Array<Asset> = [
    //LocalDatabase
    {
      url: "/clothing_combinations_db.json",
      asset: require("../assets/localDatabase/clothing_combinations_db.json"),
    },
    {
      url: "/clothing_exceptions_db.json",
      asset: require("../assets/localDatabase/clothing_exceptions_db.json"),
    },
    {
      url: "/clothes_db.json",
      asset: require("../assets/localDatabase/clothes_db.json"),
    },
    {
      url: "/clothing_categories_db.json",
      asset: require("../assets/localDatabase/clothing_categories_db.json"),
    },
    {
      url: "/age_location_pairs_db.json",
      asset: require("../assets/localDatabase/age_location_pairs_db.json"),
    },
    {
      url: "/clothing_palettes_db.json",
      asset: require("../assets/localDatabase/clothing_palettes_db.json"),
    },
    {
      url: "/wiki_category_db.json",
      asset: require("../assets/localDatabase/wiki_category_db.json"),
    },
    {
      url: "/mock_db.json",
      asset: require("../assets/localDatabase/mock_db.json"),
    },
    {
      url: "/materials_db.json",
      asset: require("../assets/localDatabase/materials_db.json"),
    },
    {
      url: "/clothing_palettes_db.json",
      asset: require("../assets/localDatabase/clothing_palettes_db.json"),
    },
    {
      url: "/wiki_db.json",
      asset: require("../assets/localDatabase/wiki_db.json"),
    },
    //icons
    {
      url: "/icon_select.svg",
      asset: SelectIcon,
    },
    {
      url: "/suggestions_info.svg",
      asset: SuggestionsInfoIcon,
    },
    {
      url: "/wiki_category_1.svg",
      asset: WikiCategory1,
    },
    {
      url: "/wiki_category_2.svg",
      asset: WikiCategory2,
    },
    {
      url: "/wiki_category_3.svg",
      asset: WikiCategory3,
    },
    {
      url: "/wiki_category_4.svg",
      asset: WikiCategory4,
    },
    {
      url: "/close_icon.svg",
      asset: CloseIcon,
    },
    {
      url: "/ABS_1.svg",
      asset: ABS1,
    },
    {
      url: "/ABS_2.svg",
      asset: ABS2,
    },
    {
      url: "/ABS_3.svg",
      asset: ABS3,
    },
    {
      url: "/ABS_4.svg",
      asset: ABS4,
    },
    {
      url: "/ABS_5.svg",
      asset: ABS5,
    },
    {
      url: "/EVA_1.svg",
      asset: EVA1,
    },
    {
      url: "/EVA_2.svg",
      asset: EVA2,
    },
    {
      url: "/EVA_3.svg",
      asset: EVA3,
    },
    {
      url: "/EVA_4.svg",
      asset: EVA4,
    },
    {
      url: "/EVA_5.svg",
      asset: EVA5,
    },
    {
      url: "/TOG_1.svg",
      asset: TOG1,
    },
    {
      url: "/TOG_2.svg",
      asset: TOG2,
    },
    {
      url: "/TOG_3.svg",
      asset: TOG3,
    },
    {
      url: "/TOG_4.svg",
      asset: TOG4,
    },
    {
      url: "/TOG_5.svg",
      asset: TOG5,
    },
    {
      url: "/cart.svg",
      asset: CartIcon,
    },
    //images
    {
      url: "/kenguru_logo.png",
      asset: KenguruGoldIcon,
    },
    //Garments
    {
      url: "1023",
      asset: require("../assets/images/garmentImage_db/1023.jpg"),
    },
    {
      url: "1033",
      asset: require("../assets/images/garmentImage_db/1033.jpg"),
    },
    {
      url: "1053",
      asset: require("../assets/images/garmentImage_db/1053.jpg"),
    },
    {
      url: "1113",
      asset: require("../assets/images/garmentImage_db/1113.jpg"),
    },
    {
      url: "1143",
      asset: require("../assets/images/garmentImage_db/1143.jpg"),
    },
    {
      url: "1213",
      asset: require("../assets/images/garmentImage_db/1213.jpg"),
    },
    {
      url: "1223",
      asset: require("../assets/images/garmentImage_db/1223.jpg"),
    },
    {
      url: "1283",
      asset: require("../assets/images/garmentImage_db/1283.jpg"),
    },
    {
      url: "1303",
      asset: require("../assets/images/garmentImage_db/1303.jpg"),
    },
    {
      url: "1530",
      asset: require("../assets/images/garmentImage_db/1530.jpg"),
    },
    {
      url: "2535",
      asset: require("../assets/images/garmentImage_db/2535.jpg"),
    },
    {
      url: "2545",
      asset: require("../assets/images/garmentImage_db/2545.jpg"),
    },
    {
      url: "101",
      asset: require("../assets/images/garmentImage_db/101.jpg"),
    },
    {
      url: "102",
      asset: require("../assets/images/garmentImage_db/102.jpg"),
    },
    {
      url: "103",
      asset: require("../assets/images/garmentImage_db/103.jpg"),
    },
    {
      url: "104",
      asset: require("../assets/images/garmentImage_db/104.jpg"),
    },
    {
      url: "105",
      asset: require("../assets/images/garmentImage_db/105.jpg"),
    },
    {
      url: "106",
      asset: require("../assets/images/garmentImage_db/106.jpg"),
    },
    {
      url: "110",
      asset: require("../assets/images/garmentImage_db/110.jpg"),
    },
    {
      url: "111",
      asset: require("../assets/images/garmentImage_db/111.jpg"),
    },
    {
      url: "112",
      asset: require("../assets/images/garmentImage_db/112.jpg"),
    },
    {
      url: "114",
      asset: require("../assets/images/garmentImage_db/114.jpg"),
    },
    {
      url: "116",
      asset: require("../assets/images/garmentImage_db/116.jpg"),
    },
    {
      url: "119",
      asset: require("../assets/images/garmentImage_db/119.jpg"),
    },
    {
      url: "121",
      asset: require("../assets/images/garmentImage_db/121.jpg"),
    },
    {
      url: "126",
      asset: require("../assets/images/garmentImage_db/126.jpg"),
    },
    {
      url: "127",
      asset: require("../assets/images/garmentImage_db/127.jpg"),
    },
    {
      url: "128",
      asset: require("../assets/images/garmentImage_db/128.jpg"),
    },
    {
      url: "129",
      asset: require("../assets/images/garmentImage_db/129.jpg"),
    },
    {
      url: "130",
      asset: require("../assets/images/garmentImage_db/130.jpg"),
    },
    {
      url: "131",
      asset: require("../assets/images/garmentImage_db/131.jpg"),
    },
    {
      url: "142",
      asset: require("../assets/images/garmentImage_db/142.jpg"),
    },

    {
      url: "143",
      asset: require("../assets/images/garmentImage_db/143.jpg"),
    },
    {
      url: "155",
      asset: require("../assets/images/garmentImage_db/155.jpg"),
    },

    {
      url: "224",
      asset: require("../assets/images/garmentImage_db/224.jpg"),
    },
    {
      url: "225",
      asset: require("../assets/images/garmentImage_db/225.jpg"),
    },
    {
      url: "253",
      asset: require("../assets/images/garmentImage_db/253.jpg"),
    },
    {
      url: "254",
      asset: require("../assets/images/garmentImage_db/254.jpg"),
    },
    {
      url: "255",
      asset: require("../assets/images/garmentImage_db/255.jpg"),
    },
    {
      url: "256",
      asset: require("../assets/images/garmentImage_db/256.jpg"),
    },
    {
      url: "270",
      asset: require("../assets/images/garmentImage_db/270.jpg"),
    },
    {
      url: "271",
      asset: require("../assets/images/garmentImage_db/271.png"),
    },
    {
      url: "1043",
      asset: require("../assets/images/garmentImage_db/1043.jpg"),
    },
    {
      url: "1063",
      asset: require("../assets/images/garmentImage_db/1063.jpg"),
    },
    {
      url: "1102",
      asset: require("../assets/images/garmentImage_db/1102.jpg"),
    },
    {
      url: "1142",
      asset: require("../assets/images/garmentImage_db/1142.jpg"),
    },
    {
      url: "1163",
      asset: require("../assets/images/garmentImage_db/1163.jpg"),
    },
    {
      url: "1194",
      asset: require("../assets/images/garmentImage_db/1194.jpg"),
    },
    {
      url: "1211",
      asset: require("../assets/images/garmentImage_db/1211.jpg"),
    },
    {
      url: "1313",
      asset: require("../assets/images/garmentImage_db/1313.jpg"),
    },
    {
      url: "1423",
      asset: require("../assets/images/garmentImage_db/1423.jpg"),
    },
    {
      url: "1433",
      asset: require("../assets/images/garmentImage_db/1433.jpg"),
    },
    {
      url: "1455",
      asset: require("../assets/images/garmentImage_db/1455.jpg"),
    },
    {
      url: "1462",
      asset: require("../assets/images/garmentImage_db/1462.jpg"),
    },
    {
      url: "1471",
      asset: require("../assets/images/garmentImage_db/1471.jpg"),
    },
    {
      url: "1553",
      asset: require("../assets/images/garmentImage_db/1553.jpg"),
    },
    {
      url: "2566",
      asset: require("../assets/images/garmentImage_db/2566.jpg"),
    },
    {
      url: "2705",
      asset: require("../assets/images/garmentImage_db/2705.jpg"),
    },
    {
      url: "2716",
      asset: require("../assets/images/garmentImage_db/2716.png"),
    },
    {
      url: "2892",
      asset: require("../assets/images/garmentImage_db/2892.jpg"),
    },
    {
      url: "3045",
      asset: require("../assets/images/garmentImage_db/3045.jpg"),
    },
    {
      url: "3055",
      asset: require("../assets/images/garmentImage_db/3055.jpg"),
    },
    {
      url: "3065",
      asset: require("../assets/images/garmentImage_db/3065.jpg"),
    },
    {
      url: "3075",
      asset: require("../assets/images/garmentImage_db/3075.jpg"),
    },
    {
      url: "3085",
      asset: require("../assets/images/garmentImage_db/3085.jpg"),
    },
    {
      url: "3095",
      asset: require("../assets/images/garmentImage_db/3095.jpg"),
    },
    {
      url: "8031",
      asset: require("../assets/images/garmentImage_db/8031.jpg"),
    },
    {
      url: "7",
      asset: require("../assets/images/garmentImage_db/7.jpg"),
    },
    {
      url: "8",
      asset: require("../assets/images/garmentImage_db/8.jpg"),
    },
    {
      url: "1024",
      asset: require("../assets/images/garmentImage_db/1024.jpg"),
    },
    {
      url: "1034",
      asset: require("../assets/images/garmentImage_db/1034.jpg"),
    },
    {
      url: "1044",
      asset: require("../assets/images/garmentImage_db/1044.jpg"),
    },
    {
      url: "1064",
      asset: require("../assets/images/garmentImage_db/1064.jpg"),
    },
    {
      url: "1103",
      asset: require("../assets/images/garmentImage_db/1103.jpg"),
    },
    {
      url: "1104",
      asset: require("../assets/images/garmentImage_db/1104.jpg"),
    },
    {
      url: "1114",
      asset: require("../assets/images/garmentImage_db/1114.jpg"),
    },
    {
      url: "1212",
      asset: require("../assets/images/garmentImage_db/1212.jpg"),
    },
    {
      url: "1214",
      asset: require("../assets/images/garmentImage_db/1214.jpg"),
    },
    {
      url: "1293",
      asset: require("../assets/images/garmentImage_db/1293.jpg"),
    },
    {
      url: "1473",
      asset: require("../assets/images/garmentImage_db/1473.jpg"),
    },
    {
      url: "1474",
      asset: require("../assets/images/garmentImage_db/1474.jpg"),
    },
    {
      url: "2716",
      asset: require("../assets/images/garmentImage_db/2716.jpg"),
    },
    {
      url: "2894",
      asset: require("../assets/images/garmentImage_db/2894.jpg"),
    },
    {
      url: "3015",
      asset: require("../assets/images/garmentImage_db/3015.jpg"),
    },
    {
      url: "3114",
      asset: require("../assets/images/garmentImage_db/3114.jpg"),
    },
    {
      url: "3141",
      asset: require("../assets/images/garmentImage_db/3141.jpg"),
    },
    {
      url: "1293",
      asset: require("../assets/images/garmentImage_db/1293.png"),
    },
    {
      url: "3142",
      asset: require("../assets/images/garmentImage_db/3142.png"),
    },
    {
      url: "4084",
      asset: require("../assets/images/garmentImage_db/4084.png"),
    },
    {
      url: "5012",
      asset: require("../assets/images/garmentImage_db/5012.png"),
    },
  ];

  static getAsset = (url: string) => {
    const found = this.assets.find((asset) => asset.url === url);
    return found ? found.asset : null;
  };

  static getWikiAsset = (url: string) => {
    let asset = null;

    try {
      asset = require("../assets/images/wiki/" + url);
    } catch (error) {}
    return asset;
  };

  static getGarmentInfoAssets = (url: string) => {
    let asset = null;

    try {
      asset = require("../assets/images/garmentInfoImage_db/" + url + ".jpg");
    } catch (error) {}
    return asset;
  };
}
export default AssetManager;
